import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Button } from 'semantic-ui-react';
import axios from 'axios';
import { PhishingTemplateModal } from 'components';

class CtPhishingTemplateAdd extends Component {
  state = {
    onProgress: false,
    modalStatus: false,
    newTemplateNo: 0
  };

  toggleModal = () => this.setState({ modalStatus: !this.state.modalStatus });
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { modalStatus } = this.state;

    return (
      <div>
        <Button
          className="bt-style-gleam common-button-brand"
          size="small"
          content={defineMessages(
            formatMessage({
              id: 'CtExamTemplateAdd_1',
              defaultMessage: '등 록'
            })
          )}
          onClick={this.toggleModal}
          color="blue"
        />
        {modalStatus && (
          <PhishingTemplateModal
            isAuth={this.props.isAuth}
            config={{ mode: 'add', phishingInfo: null }}
            toggleModal={this.toggleModal}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(CtPhishingTemplateAdd);



// WEBPACK FOOTER //
// ./src/script/containers/phishingTemplate/CtPhishingTemplateAdd.js